import React from "react";
import { IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
import { useParams } from "react-router";
import "./IllyCaffeModalContentStyle.css";

export default function IllyModalContent({ closerHandler }) {
    const { type, id } = useParams();

    return (
        <div className="illy-modal-content modal-wrapper overflow-auto p-4 flex flex-col gap-4 text-black">
            <div className="sticky top-0">
                <div className="flex flex-row justify-end">
                    <button type="button" onClick={closerHandler} className="text-2xl flex items-center justify-center">
                        <IonIcon slot="icon-only" icon={close}></IonIcon>
                    </button>
                </div>
            </div>

            <img src="/assets/illy-caffe.png" alt="login call to action" />

            <p className="text-center font-bold" >Scopri il Caffè Espresso Illy</p>
            <p className="text-center" >Hai apprezzato il nostro espresso? Porta a casa tua tutto il gusto del Caffè Illy:</p>
            <a className="py-2 px-4 rounded-full text-center" style={{ backgroundColor: "#512c1f", color: "white" }} href="https://www.illy.com/it-it/caffe">Ordina direttamente da qui</a>
        </div>
    );
}
